"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_2 = require("@emotion/react");
var material_1 = require("@mui/material");
var icons_1 = require("../icons");
var classes = {
    main: {
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
        backgroundColor: 'white',
        borderRadius: '10px',
    },
    info: {
        p: { xs: 4, lg: 8 },
        display: 'flex',
        flexDirection: 'column',
    },
    bottom: {
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
        mt: 4,
        '&>*+*': {
            ml: { lg: 6 },
            mt: { xs: 4, lg: 0 },
        },
    },
    about: {
        '&>h5': {
            color: function (theme) { return theme.palette.secondary.main; },
            fontWeight: 600,
            mb: 2,
        },
    },
    about_more: {
        '&>h5': {
            fontSize: '1.2rem',
            fontWeight: 500,
            mb: { xs: 0, lg: 2 },
        },
    },
    more: {
        p: { xs: 4, lg: 12 },
        backgroundColor: '#F9F9F9',
        borderRadius: { xs: '0 0 10px 10px', lg: '0 10px 10px 0' },
        display: 'flex',
        flexDirection: { lg: 'column' },
        justifyContent: { lg: 'center' },
        alignItems: { xs: 'center', lg: 'baseline' },
        '&>img': {
            height: 'auto',
            width: 'auto',
            maxWidth: '60px',
            maxHeight: '60px',
        },
    },
    links: {
        display: 'flex',
        flexDirection: 'column',
        mt: { lg: 4 },
        ml: { xs: 4, lg: 0 },
        '&>*+*': {
            mt: 4,
        },
    },
    organizationLogo: {
        width: 60,
        height: 60,
        '& > img': {
            objectFit: 'contain',
        },
    },
};
var companyLinkCss = (0, react_2.css)({
    textDecoration: 'none',
    color: 'black',
    display: 'flex',
});
var CompanyCard = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var vacancy = _a.vacancy;
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, sx: classes.main }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 12, lg: 8, sx: classes.info }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: classes.about }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ variant: "h5" }, { children: ["Over ", (_b = vacancy.organization) === null || _b === void 0 ? void 0 : _b.name] })), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", dangerouslySetInnerHTML: { __html: ((_c = vacancy.organization) === null || _c === void 0 ? void 0 : _c.description) || '' } })] })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: classes.bottom }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: classes.about_more }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h5" }, { children: "Locatie" })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body1" }, { children: (_d = vacancy.organization) === null || _d === void 0 ? void 0 : _d.locationAddress }))] })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: classes.about_more }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h5" }, { children: "Aantal medewerkers" })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body1" }, { children: (_e = vacancy.organization) === null || _e === void 0 ? void 0 : _e.amountOfEmployees }))] }))] }))] })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 12, lg: 4, sx: classes.more }, { children: [(0, jsx_runtime_1.jsx)(material_1.Avatar, { variant: "square", src: (_f = vacancy.organization) === null || _f === void 0 ? void 0 : _f.logo, alt: (_g = vacancy.organization) === null || _g === void 0 ? void 0 : _g.name, sx: classes.organizationLogo }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: classes.links }, { children: [false && ((0, jsx_runtime_1.jsxs)(react_router_dom_1.NavLink, __assign({ css: companyLinkCss, to: "/company/page" }, { children: [(0, jsx_runtime_1.jsx)("span", { children: "Lees meer" }), (0, jsx_runtime_1.jsx)(icons_1.ArrowRightIcon, { sx: { color: 'primary.main', ml: 2 } })] }))), false && ((0, jsx_runtime_1.jsxs)(react_router_dom_1.NavLink, __assign({ css: companyLinkCss, to: "/company/page" }, { children: [(0, jsx_runtime_1.jsx)("span", { children: "Set up job alert" }), (0, jsx_runtime_1.jsx)(icons_1.ArrowRightIcon, { sx: { color: 'primary.main', ml: 2 } })] })))] }))] }))] })));
};
exports.default = CompanyCard;
